import { render } from "./SensorSetting.vue?vue&type=template&id=4dfdfe81"
import script from "./SensorSetting.vue?vue&type=script&lang=js"
export * from "./SensorSetting.vue?vue&type=script&lang=js"

import "./SensorSetting.vue?vue&type=style&index=0&id=4dfdfe81&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__